import { render } from "./PantryDateValueDialog.vue?vue&type=template&id=3e9732d8&ts=true"
import script from "./PantryDateValueDialog.vue?vue&type=script&lang=ts"
export * from "./PantryDateValueDialog.vue?vue&type=script&lang=ts"

import "./PantryDateValueDialog.vue?vue&type=style&index=0&id=3e9732d8&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__